import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography } from 'antd';
import { toast } from '../../../lib/toast';
import { Link } from 'react-router-dom';
import { forgotPasswordApi } from '../api/auth';
import AuthPageShell from '../../../components/AuthPageShell';

const { Text, Paragraph } = Typography;

interface FormValues {
  email: string;
}

const ForgotPasswordPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const onFinish = async (values: FormValues) => {
    setLoading(true);
    try {
      const result = await forgotPasswordApi(values.email);
      if (result.success) {
        setSubmitted(true);
      } else {
        toast.error(result.error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageShell>
      <Card style={{ width: '100%', maxWidth: 420 }}>
        <Typography.Title level={3} style={{ marginTop: 0 }}>
          Forgot password
        </Typography.Title>
        {submitted ? (
          <>
            <Paragraph>
              If an account exists for that email, you will receive instructions shortly.
            </Paragraph>
            <Link to="/login">Back to sign in</Link>
          </>
        ) : (
          <>
            <Text type="secondary">
              Enter your email and we will send you a link to reset your password.
            </Text>
            <Form
              layout="vertical"
              onFinish={onFinish}
              style={{ marginTop: 16 }}
              autoComplete="off"
            >
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: 'Please enter your email' },
                  { type: 'email', message: 'Please enter a valid email' },
                ]}
              >
                <Input placeholder="you@example.com" />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading} block>
                  Send reset link
                </Button>
              </Form.Item>
            </Form>
            <Link to="/login">Back to sign in</Link>
          </>
        )}
      </Card>
    </AuthPageShell>
  );
};

export default ForgotPasswordPage;
